import { inject, Injectable } from '@angular/core';

import { SettingsService } from './settings.service';

@Injectable({
  providedIn: 'root',
})
export class MockService {
  private readonly settingsService = inject(SettingsService);

  public async init$(): Promise<void> {
    // Build-time gate first: with FEATURE_MOCK_DATA === false esbuild turns the rest of
    // this method into dead code, so the mock server can never start in a release.
    //
    // This alone does NOT keep the fixtures out of the artifact: esbuild still emits the
    // code-split chunk behind the dynamic import() below (~480 kB, unreferenced but on
    // disk, and copied into the native app by `cap sync`). Removing the data is the job
    // of the `mock-rest.ts` -> `mock-rest.noop.ts` fileReplacement in project.json, which
    // every released configuration must keep. Both layers are required — see
    // mock-rest.noop.ts. Never turn this back into a static import.
    if (!FEATURE_MOCK_DATA) return;

    const useDemoData = await this.settingsService.isUseDemoData$();
    if (!useDemoData) return;

    const { default: mockRESTServer } = await import('../../mocks/mock-rest');
    mockRESTServer();
  }
}
